import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
  EXPORTAR_NOTA_FISCAL_DEVEDOR, GERAR_NOTA_FISCAL_DEVEDOR, SET_BUSCAR_DADOS_TABELA,
} from './NotaFiscalDevedor.constants';
import NotaFiscalDevedorService from '../../services/core/notaFiscalDevedor/NotaFiscalDevedorService';
import { setCommonAction, setSimpleNotasFiscaisDevedorAction } from './NotaFiscalDevedor.store';
import { downloadFileSispag } from '../../helpers';

function* successPesquisarNotaFiscalDevedor(data) {
  yield put(setSimpleNotasFiscaisDevedorAction('tableView', data.data.content));
  yield put(setSimpleNotasFiscaisDevedorAction('totalElements', data.data.totalElements));
  yield put(setSimpleNotasFiscaisDevedorAction('rowsPerPage', data.data.pageable.pageSize));
  yield put(setSimpleNotasFiscaisDevedorAction('page', data.data.pageable.pageNumber));
}

function* emptyPesquisaNotaFiscalDevedor() {
  yield put(setSimpleNotasFiscaisDevedorAction('tableView', []));
  yield put(setSimpleNotasFiscaisDevedorAction('totalElements', 0));
}

function* buscarDadosTabelaHandler(actions) {
  yield put(setCommonAction('loadingPage', true));
  const page = yield select(states => states.page);
  const rowsPerPage = yield select(states => states.rowsPerPage);
  const columnOrdenacao = yield select(states => states.columnOrdenacao);
  const listIds = yield select(states => states.listIds);
  const formFields = yield select(states => states.formFields);
  const idsProcessosExcluidos = yield select(states => states.idsProcessosExcluidos);
  const storedListIds = new Map();

  try {
    const order = [`${columnOrdenacao.element},${columnOrdenacao.order}`];
    const response = yield call(NotaFiscalDevedorService.buscarInfoNotaFiscalDevedor, formFields, { page, size: rowsPerPage }, order, idsProcessosExcluidos);
    yield successPesquisarNotaFiscalDevedor(response);
    if (actions.atualizarListaIds === true) {
      const responseIds = yield call(NotaFiscalDevedorService.buscarIdsNotaFiscalDevedor, formFields, idsProcessosExcluidos);
      Object.keys(listIds).forEach((key) => {
        storedListIds.set(parseInt(key, 10), listIds[key]);
      });
      const ids = responseIds.data.reduce((acumulador, id) => ({ ...acumulador, [id]: false }), {});
      yield put(setSimpleNotasFiscaisDevedorAction('listIds', ids));

      const responseResumo = yield call(NotaFiscalDevedorService.buscarResumoNotaFiscalDevedor, formFields, idsProcessosExcluidos);
      yield put(setSimpleNotasFiscaisDevedorAction('dadosResumo', responseResumo.data));
    }
  } catch (e) {
    yield emptyPesquisaNotaFiscalDevedor();
  } finally {
    yield put(setCommonAction('loadingPage', false));
  }
}

function* gerarNotaFiscalDevedorHandler(actions) {
  yield put(setCommonAction('loadingPage', true));
  try {
    yield call(NotaFiscalDevedorService.gerarNotaFiscalDevedor, actions.conteudoSelecionado);
    yield buscarDadosTabelaHandler({ atualizarListaIds: true });
    toast.success('Nota fiscal devedor gerada com sucesso!');
  } catch (e) {
    yield emptyPesquisaNotaFiscalDevedor();
    toast.error('Erro ao gerar nota fiscal devedor!');
  } finally {
    yield put(setCommonAction('loadingPage', false));
  }
}

function* exportarNotaFiscalDevedorHandler() {
  yield put(setCommonAction('loadingPage', true));
  const formFields = yield select(states => states.formFields);
  const dadosResumo = yield select(states => states.dadosResumo);
  try {
    const response = yield call(NotaFiscalDevedorService.exportarNotaFiscalDevedor, formFields, dadosResumo);
    if (response.data.length > 0) {
      downloadFileSispag(response.headers.filename, response.data);
    } else {
      toast.error('Nenhuma nota fiscal devedor encontrada para exportação.');
    }
  } catch (e) {
    toast.error('Erro ao gerar o Excel. Tente novamente mais tarde.');
  } finally {
    yield put(setCommonAction('loadingPage', false));
  }
}

export const buscarDadosTabelaAction = atualizarListaIds => ({
  type: SET_BUSCAR_DADOS_TABELA,
  atualizarListaIds,
});

export const gerarNotaFiscalDevedorAction = conteudoSelecionado => ({
  type: GERAR_NOTA_FISCAL_DEVEDOR,
  conteudoSelecionado,
});

export const exportarNotaFiscalDevedorAction = () => ({
  type: EXPORTAR_NOTA_FISCAL_DEVEDOR,
});

export default function* watchNotaFiscalDevedor() {
  yield takeLatest(SET_BUSCAR_DADOS_TABELA, buscarDadosTabelaHandler);
  yield takeLatest(GERAR_NOTA_FISCAL_DEVEDOR, gerarNotaFiscalDevedorHandler);
  yield takeLatest(EXPORTAR_NOTA_FISCAL_DEVEDOR, exportarNotaFiscalDevedorHandler);
}
